import React, { Component } from "react";
import { GetUserLogin, GetWalletDetails } from "../../../../services";
import "../css/index.css";
import "./wallet.css";
import ApiClient from "../../../../../utils/ApiClient";
import { NotificationManager } from "react-notifications";
import Loading from "react-fullscreen-loading";

export default class Wallet extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {},
      wallet: null,
      loadingWallet: true,
      walletTransactions: [],
      loadingTransactions: false,
      showTopupModal: false,
      walletPackages: [],
      selectedPackage: null,
      processingPayment: false,
      reconcileMessage: "",
      showConfirmationModal: false,
      pendingPayment: false,
    };
  }
  async componentDidMount() {
    let email = sessionStorage.getItem("email");
    if (email) {
      let value = await GetUserLogin.getCustomerDetail(email);
      if (value?.data) {
        const user = value.data;
        this.setState({ user });
        const res = await GetWalletDetails.reconcilePreWalletByCustomer(
          user.id,
        );

        if (res?.message) {
          this.setState({ reconcileMessage: res.message });

          // ✅ Show Notification
          NotificationManager.info(res.message);
        }

        this.fetchWallet(user.id);
      }
    }
  }

  fetchWallet = async (userId) => {
    try {
      const res = await GetWalletDetails.getWalletByCustomerId(userId);

      this.setState(
        {
          wallet: res?.data || null,
          loadingWallet: false,
          loadingTransactions: true,
        },
        async () => {
          if (res?.data) {
            const transactions =
              await GetWalletDetails.getWalletTransactionsByCustomerId(userId);

            this.setState({
              walletTransactions: transactions,
              loadingTransactions: false,
            });
          }
        },
      );
    } catch (err) {
      this.setState({
        wallet: null,
        loadingWallet: false,
        loadingTransactions: false,
      });
    }
  };

  activateWallet = async () => {
    const { user } = this.state;
    await GetWalletDetails.getWalletCreate(user.id);
    this.fetchWallet(user.id);
  };

  openTopupModal = async () => {
    const packages = await GetWalletDetails.getAllWalletPackageList();
    this.setState({
      walletPackages: packages?.data || [],
      showTopupModal: true,
    });
  };

  closeTopupModal = () => {
    this.setState({
      showTopupModal: false,
      selectedPackage: null,
    });
  };

  startWalletTopup = async () => {
    const { user, selectedPackage } = this.state;

    this.setState({ processingPayment: true });

    try {
      const payload = {
        custId: user.id,
        custEmail: user.email,
        custPhone: user.phone,
        packageId: selectedPackage.id,
      };

      const response = await ApiClient.sendPostRequest(
        "https://jccreations.boutique/api/wallet/walletwebhdfctopup",
        payload,
      );

      const iframeUrl = response?.sdk_payload?.payment_links?.web;
      const orderId = response?.orderId;

      if (!iframeUrl || !orderId) throw new Error("Payment initiation failed");

      // ✅ Open HDFC payment in same tab
      window.location.href = iframeUrl;
    } catch (err) {
      console.error("HDFC Payment Error:", err);
      NotificationManager.error(err.message || "Payment initialization failed");
      this.setState({ processingPayment: false });
    }
  };

  handleLogout = async (event) => {
    event.preventDefault();
    await GetUserLogin.logout();
  };

  handleCancel = () => {
    this.setState({ showConfirmationModal: false });
  };

  handleAgree = async () => {
    this.setState(
      {
        showConfirmationModal: false, // close confirmation modal
        showTopupModal: false, // close package modal
        processingPayment: true, // show loader
      },
      () => {
        this.startWalletTopup(); // start payment
      },
    );
  };

  render() {
    let { user } = this.state;
    return (
      <div className="wrapper">
        {this.state.processingPayment && (
          <Loading loading loaderColor="#f55d2c" />
        )}

        <div className="gambo-Breadcrumb">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a href="/">Home </a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      User Dashboard
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
        <div className="dashboard-group">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="user-dt">
                  <div className="user-img">
                    <img
                      src={user.profilephoto || "/img/avatar/img-5.jpg"}
                      alt="Avatar"
                      style={{
                        width: "120px",
                        height: "120px",
                        objectFit: "cover",
                        borderRadius: "50%",
                      }}
                      onError={(e) => {
                        e.target.src = "/img/avatar/img-5.jpg";
                      }}
                    />
                    {/* <div className="img-add">
                      <input type="file" id="file" />
                      <label htmlFor="file">
                        <i className="uil uil-camera-plus" />
                      </label>
                    </div> */}
                  </div>
                  <h4>{user.fullName}</h4>
                  <p>+91 {user.phone}</p>
                  {/* <div className="earn-points"><img src="images/Dollar.svg" alt />Points : <span>20</span></div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className>
          <div className="container">
            <div className="row">
              <div className="col-lg-3 col-md-4">
                <div className="left-side-tabs">
                  <div className="dashboard-left-links">
                    <a href="/account/view" className="user-item">
                      <i className="uil uil-apps" />
                      Overview
                    </a>
                    <a href="/account/wallet" className="user-item  active">
                      <i className="uil uil-wallet" />
                      Wallet
                    </a>
                    <a href="/account/profile" className="user-item">
                      <i className="mdi mdi-account-outline" />
                      My profile
                    </a>
                    <a href="/account/order/list" className="user-item">
                      <i className="uil uil-box" />
                      Downloads
                    </a>
                    {/* <a href="/account/rewards" className="user-item"><i className="uil uil-gift" />My Rewards</a> */}
                    <a href="/account/wishlist" className="user-item">
                      <i className="uil uil-heart" />
                      Shopping Wishlist
                    </a>
                    <a href="/account/address" className="user-item">
                      <i className="uil uil-location-point" />
                      My Address
                    </a>
                    <a className="user-item" onClick={this.handleLogout}>
                      <i className="uil uil-exit" />
                      Logout
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-9 col-md-8">
                <div className="dashboard-right">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="main-title-tab">
                        <h4>
                          <i className="uil uil-apps" />
                          Overview
                        </h4>
                      </div>
                      <div className="welcome-text">
                        <h2>Hi! {user.fullName}</h2>
                      </div>
                    </div>
                    {/* <div className="col-lg-6 col-md-12">
                                            <div className="pdpt-bg">
                                                <div className="pdpt-title">
                                                    <h4>My Rewards</h4>
                                                </div>
                                                <div className="ddsh-body">
                                                    <h2>6 Rewards</h2>
                                                    <ul>
                                                        <li>
                                                            <a href="#" className="small-reward-dt hover-btn">Won $2</a>
                                                        </li>
                                                        <li>
                                                            <a href="#" className="small-reward-dt hover-btn">Won 40% Off</a>
                                                        </li>
                                                        <li>
                                                            <a href="#" className="small-reward-dt hover-btn">Caskback $1</a>
                                                        </li>
                                                        <li>
                                                            <a href="#" className="rewards-link5">+More</a>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <a href="#" className="more-link14">Rewards and Details <i className="uil uil-angle-double-right" /></a>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-12">
                                            <div className="pdpt-bg">
                                                <div className="pdpt-title">
                                                    <h4>Downloads</h4>
                                                </div>
                                                <div className="ddsh-body">
                                                    <h2>2 Recently Purchases</h2>
                                                    <ul className="order-list-145">
                                                        <li>
                                                            <div className="smll-history">
                                                                <div className="order-title">2 Items <span data-inverted data-tooltip="2kg broccoli, 1kg Apple" data-position="top center">?</span></div>
                                                                <div className="order-status">On the way</div>
                                                                <p>$22</p>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <a href="#" className="more-link14">All Orders <i className="uil uil-angle-double-right" /></a>
                                            </div>
                                        </div> */}

                    <div className="col-lg-12 col-md-12">
                      <div className="pdpt-bg">
                        <div className="pdpt-title">
                          <h4>My Wallet</h4>
                        </div>

                        {this.state.loadingWallet ? (
                          <p>Loading wallet...</p>
                        ) : this.state.wallet ? (
                          /* ✅ Wallet Exists */
                          <div className="wllt-body wallet-active">
                            <h2 className="wallet-balance">
                              Balance ₹{this.state.wallet.balance}
                            </h2>

                            <button
                              className="btn wallet-topup-btn mb-3"
                              onClick={this.openTopupModal}
                            >
                              <i className="uil uil-wallet" /> Top-up Wallet
                            </button>

                            {/* <ul className="wallet-list">
                              <li>
                                <a className="wallet-links14">
                                  <i className="uil uil-card-atm" /> Payment
                                  Methods
                                </a>
                              </li>
                              <li>
                                <a className="wallet-links14">
                                  <i className="uil uil-gift" /> Offers
                                </a>
                              </li>
                              <li>
                                <a className="wallet-links14">
                                  <i className="uil uil-coins" /> Points
                                </a>
                              </li>
                            </ul> */}
                          </div>
                        ) : (
                          /* ❌ Wallet Not Exists */
                          <div className="wllt-body wallet-empty">
                            <div className="wallet-empty-card">
                              <div className="wallet-icon">
                                <i className="uil uil-wallet" />
                              </div>

                              <h3>Activate Your Wallet</h3>
                              <p>
                                Create your wallet to enjoy quick payments,
                                cashback, offers, and seamless checkout
                                experience.
                              </p>

                              <button
                                className="btn btn-primary wallet-activate-btn"
                                onClick={this.activateWallet}
                              >
                                Activate Wallet
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                      {/* ================= Wallet Transactions ================= */}
                      {this.state.wallet && (
                        <div className="pdpt-bg mt-4">
                          <div className="pdpt-title">
                            <h4>Wallet Transactions</h4>
                          </div>

                          {this.state.loadingTransactions ? (
                            <p className="p-3">Loading transactions...</p>
                          ) : this.state.walletTransactions.length === 0 ? (
                            <p className="p-3 text-muted">
                              No wallet transactions found
                            </p>
                          ) : (
                            <div className="table-responsive">
                              <table className="table table-bordered wallet-table">
                                <thead>
                                  <tr>
                                    <th>#</th>
                                    <th>Date</th>
                                    <th>Time</th>
                                    <th>Type</th>
                                    <th>Source</th>
                                    <th>Reference</th>
                                    <th className="text-end">Amount (₹)</th>
                                  </tr>
                                </thead>

                                <tbody>
                                  {this.state.walletTransactions.map(
                                    (txn, index) => {
                                      const createdAt = txn.createdAt
                                        ? new Date(txn.createdAt)
                                        : null;

                                      return (
                                        <tr key={txn.id}>
                                          <td>{index + 1}</td>

                                          {/* Date from backend createdAt */}
                                          <td>
                                            {createdAt
                                              ? createdAt.toLocaleDateString(
                                                  "en-IN",
                                                  {
                                                    day: "2-digit",
                                                    month: "2-digit",
                                                    year: "numeric",
                                                  },
                                                )
                                              : "-"}
                                          </td>

                                          {/* Time from backend createdAt */}
                                          <td>
                                            {createdAt
                                              ? createdAt.toLocaleTimeString(
                                                  "en-IN",
                                                  {
                                                    hour: "2-digit",
                                                    minute: "2-digit",
                                                    second: "2-digit",
                                                    hour12: true,
                                                  },
                                                )
                                              : "-"}
                                          </td>

                                          <td>
                                            <span
                                              className={
                                                txn.type === "CREDIT"
                                                  ? "badge bg-success"
                                                  : "badge bg-danger"
                                              }
                                            >
                                              {txn.type}
                                            </span>
                                          </td>

                                          <td>{txn.source || "-"}</td>

                                          <td>{txn.referenceId || "-"}</td>

                                          <td className="text-end fw-bold">
                                            {txn.type === "DEBIT" ? "-" : "+"}
                                            {txn.amount}
                                          </td>
                                        </tr>
                                      );
                                    },
                                  )}
                                </tbody>
                              </table>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {this.state.showTopupModal && (
                <div className="wallet-modal-overlay">
                  <div className="wallet-modal">
                    <h3>Select Wallet Package</h3>

                    <div className="wallet-package-grid">
                      {this.state.walletPackages.map((pkg) => (
                        <div
                          key={pkg.id}
                          className={`wallet-package-card ${
                            this.state.selectedPackage?.id === pkg.id
                              ? "active"
                              : ""
                          }`}
                          onClick={() =>
                            this.setState({ selectedPackage: pkg })
                          }
                        >
                          <h4>₹{pkg.amount}</h4>
                          <p>{pkg.description || "Wallet Top-up"}</p>
                        </div>
                      ))}
                    </div>

                    <div className="wallet-modal-actions">
                      <button
                        className="btn btn-secondary"
                        onClick={this.closeTopupModal}
                      >
                        Cancel
                      </button>

                      <button
                        className="btn btn-primary"
                        disabled={
                          !this.state.selectedPackage ||
                          this.state.processingPayment
                        }
                        onClick={() =>
                          this.setState({ showConfirmationModal: true })
                        }
                      >
                        Continue
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {this.state.showConfirmationModal && (
                <div
                  className="modal-backdrop"
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    backgroundColor: "rgba(0,0,0,0.6)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 9999,
                    padding: "20px",
                    boxSizing: "border-box",
                  }}
                >
                  <div
                    style={{
                      background: "#fff",
                      borderRadius: "12px",
                      width: "100%",
                      maxWidth: "500px",
                      maxHeight: "90vh",
                      overflowY: "auto",
                      boxShadow: "0 8px 20px rgba(0,0,0,0.3)",
                      padding: "20px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                    }}
                  >
                    <div style={{ overflowY: "auto" }}>
                      <h4
                        style={{
                          marginBottom: "15px",
                          fontWeight: "600",
                          color: "#333",
                        }}
                      >
                        Wallet Payment Confirmation
                      </h4>

                      <p style={{ fontSize: "15px", color: "#444" }}>
                        Please read carefully before proceeding.
                      </p>

                      <p
                        style={{
                          fontSize: "15px",
                          color: "#444",
                          marginTop: "10px",
                        }}
                      >
                        All payments made using the wallet are{" "}
                        <b>non-refundable</b>. After order completion, any{" "}
                        <b>remaining wallet balance will not be refunded</b>.
                        Wallet balance can only be used for{" "}
                        <b>future purchases</b>. Please do not request refunds
                        for wallet payments or remaining balance.
                      </p>

                      <hr style={{ margin: "15px 0" }} />

                      <p style={{ fontSize: "15px", color: "#444" }}>
                        దయచేసి కొనసాగించే ముందు చదవండి.
                      </p>

                      <p
                        style={{
                          fontSize: "15px",
                          color: "#444",
                          marginTop: "10px",
                        }}
                      >
                        వాలెట్ ద్వారా చేసిన అన్ని చెల్లింపులు{" "}
                        <b>రిఫండ్ చేయబడవు</b>. ఆర్డర్ పూర్తైన తర్వాత వాలెట్‌లో
                        మిగిలిన బ్యాలెన్స్‌కు కూడా <b>రిఫండ్ ఉండదు</b>. మిగిలిన
                        వాలెట్ బ్యాలెన్స్‌ను{" "}
                        <b>భవిష్యత్ కొనుగోళ్లకు మాత్రమే ఉపయోగించుకోవచ్చు</b>.
                        వాలెట్ పేమెంట్స్ లేదా మిగిలిన బ్యాలెన్స్‌పై దయచేసి{" "}
                        <b>రిఫండ్ కోరవద్దు</b>.
                      </p>
                    </div>

                    <div
                      style={{
                        marginTop: "15px",
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: "10px",
                        flexWrap: "wrap",
                      }}
                    >
                      <button
                        onClick={this.handleCancel}
                        style={{
                          padding: "10px 16px",
                          background: "#ccc",
                          border: "none",
                          borderRadius: "6px",
                          fontSize: "14px",
                          cursor: "pointer",
                          flex: "1 1 40%",
                        }}
                      >
                        Cancel
                      </button>

                      <button
                        onClick={this.handleAgree}
                        style={{
                          padding: "10px 16px",
                          background:
                            "linear-gradient(to right, rgba(230, 92, 91, 0.9), rgba(245, 93, 44, 0.9))",
                          color: "#fff",
                          border: "none",
                          borderRadius: "6px",
                          fontSize: "14px",
                          fontWeight: "bold",
                          cursor: "pointer",
                          flex: "1 1 40%",
                          boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                        }}
                      >
                        Agree & Continue
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
